import HBIcon from "@/components/HBIcon";
import classNames from "classnames";
import dayjs from "dayjs";
import styles from "./index.module.less";

export const FooterContent = () => {
  return (
    <div className={styles.footerContent}>
      <div>
        <span>
          © Huaban 2011 - {dayjs().format("YYYY")}
          稿定（厦门）信息服务有限公司
        </span>
        <Divider />
        <a
          className={styles.number}
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002342"
          rel="nofollow noreferrer"
        >
          互联网安全备案号: 35020602002342
        </a>
        <Divider />
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/"
          rel="nofollow noreferrer"
        >
          备案信息: 闽ICP备2021013850号-2 &nbsp;&nbsp;
        </a>
      </div>
      <div className={styles.right}>
        <HBIcon type={"ic_logo"} />
        <span>花瓣</span>
        <Divider />
        <span>稿定旗下品牌</span>
      </div>
    </div>
  );
};
export default function Footer({ relative = false, dark = false, style = {} }) {
  return (
    <div
      className={classNames([
        styles.footer,
        relative ? styles.relative : null,
        dark ? styles.dark : null,
      ])}
      {...(style ? { style } : null)}
    >
      <FooterContent />
    </div>
  );
}

function Divider() {
  return <span className={styles.divider}>&nbsp;&nbsp;|&nbsp;&nbsp;</span>;
}
